import React from 'react'
import { Link } from 'react-router-dom'

function J01() {
  return (
    <div className="entry">

      <div className="entry__main">
        <h3 classNamne="heading-tertiary">
          <Link className="heading-tertiary__link" to="/navigate">
            <span className="heading-tertiary--main">
              Introduction
            </span>
            <span className="heading-tertiary--sub">
              11/06/2022
            </span>
          </Link>
        </h3>

        <p className="entry__passage">
          The last few towns sure have been slow. Hopefully my time in Tresen will bring better fortune. 
          <br /><br />

          On the way into town I stumbled upon a family with wagon trouble.  It was no problem to help them get back on the road.  The family was awfully sweet. Elia and Dan, with their children Robert and Harry. Harry must have been named after his aunt Harriet who was along for the ride. 
          I rode with them for some time as we got closer to town before we parted ways. When I told them I make a living tinkering with odds and ends, Elia asked me to take a look at her locket. I said I surely would do what I could for such a kind stranger and we parted way, agreeing to meet in Tresen for dinner soon so I could return her locket once repaired.
          <br /><br />
          Now that I'm set up in the Tresen market, there is something quite unusual about this particular locket.
        </p>
        <p className="entry__signature">Dwayne the Shell</p>
      </div>

    </div>
  )
}

export default J01